<template>
    <div>
      <div class="top clearfix">
        <div class="demo-upload-list" v-for="(item,index) in uploadList" :key="index">
          <template v-if="item.status === 'finished'">
            <img :src="item.url">
            <div class="demo-upload-list-cover">
              <!--<Icon type="ios-eye-outline" @click.native="handleView(item)"></Icon>-->
              <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
            </div>
          </template>
          <template v-else>
            <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
          </template>
        </div>
        <Upload
          ref="upload"
          :show-upload-list="false"
          :default-file-list="defaultList"
          :on-success="handleSuccess"
          :format="['jpg','jpeg','png']"
          :max-size="2048"
          :on-format-error="handleFormatError"
          :on-exceeded-size="handleMaxSize"
          :before-upload="beforeImgUpload"
          multiple
          type="drag"
          action=""
          style="display: inline-block;width:58px;">
          <div style="width: 58px;height:58px;line-height: 58px;">
            <Icon type="ios-camera" size="20"></Icon>
          </div>
        </Upload>
        <Button type="primary" class="fr mr10 mt18" :loading="addLoading" :disabled="uploadList.length===0" @click="handleAdd">添加</Button>
        <!--<Button>批量删除</Button>-->
      </div>
      <Modal title="View Image" v-model="visible" :mask-closable="false">
        <img :src="viewImg" v-if="visible" style="width: 100%">
      </Modal>
      <div class="pic_wrap">
        <Spin fix v-show="tableLoading"></Spin>
        <div class="demo-upload-list demo-upload-list-wrap"  v-for="(item) in posterList" :key="item.id">
          <img class="pic" :src="item.poster" alt="头像">
          <div class="demo-upload-list-cover">
            <Icon type="ios-trash-outline" @click.native="handleRemovePoster(item)"></Icon>
          </div>
        </div>
      </div>
      <Page class="mt24" :total="total" :page-size="page_size" :current="page_num" show-elevator show-total  @on-change="handlePageChange"/>
    </div>
</template>

<script>
import mixins from '@/mixins/page'
import * as qiniu from 'qiniu-js'
export default {
  name: 'picture_manage',
  mixins: [mixins],
  data () {
    return {
      modalVisibile: false,
      modalLoading: false,
      addLoading: false,
      posterList: [],
      defaultList: [

      ],
      imgName: '',
      visible: false,
      uploadList: [],
      viewImg: '',
      addDisable: false,
      page_size: 155,
      tableLoading: false
    }
  },
  mounted () {
    this.uploadList = this.$refs.upload.fileList
    this.handleQuery()
  },
  methods: {
    handleCancel () {
      this.modalVisibile = false
    },
    handleModalSubmit () {

    },
    handleAdd () {
      this.addLoading = true
      let file_list = this.uploadList.map((item) => {
        return item.url
      })
      this.$api.addPicture({ file_list }).then(res => {
        if (res.code === 0) {
          this.$Message.success(res.msg)
          this.uploadList = []
          this.handleQuery()
        } else {
          this.$Message.error(res.msg)
        }
        this.addLoading = false
      })
    },
    handleView (item) {
      this.visible = true
      this.viewImg = item.url
    },
    handleRemove (file) {
      const fileList = this.$refs.upload.fileList
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1)
    },
    handleSuccess (res, file) {
      file.url = 'https://o5wwk8baw.qnssl.com/7eb99afb9d5f317c912f08b5212fd69a/avatar'
      file.name = '7eb99afb9d5f317c912f08b5212fd69a'
    },
    handleFormatError (file) {
      this.$Notice.warning({
        title: 'The file format is incorrect',
        desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
      })
    },
    handleMaxSize (file) {
      this.$Notice.warning({
        title: 'Exceeding file size limit',
        desc: 'File  ' + file.name + ' is too large, no more than 2M.'
      })
    },
    handleBeforeUpload () {
      const check = this.uploadList.length < 15
      if (!check) {
        this.$Notice.warning({
          title: 'Up to five pictures can be uploaded.'
        })
      }
      return check
    },
    beforeImgUpload (file) {
      let that = this
      // 从后台获取token和key
      this.$api.getQiToken({}).then(res => {
        if (res.code === 0) {
          let key = res.data.key
          let token = res.data.QiNiuToken
          let config = {
            useCdnDomain: true,
            region: null
          }
          let putExtra = {
            fname: '',
            params: {},
            mimeType: null
          }
          let observable = qiniu.upload(file, key, token, putExtra, config)
          observable.subscribe({
            error: function (err) {
              this.$Message.success(err)
            },
            complete: function (res) {
              that.$api.getImgPath({ key: res.key }).then(res => {
                if (res.code === 0) {
                  that.uploadList.push({ url: res.msg, status: 'finished' })
                }
              })
            }
          })
        } else {
          this.$Message.error(res.msg)
        }
      })
      return false
    },
    handleQuery () {
      this.page_num = 1
      this.getTableData()
    },
    getTableData () {
      this.tableLoading = true
      this.$api.getPictureList({ page_num: this.page_num, page_size: this.page_size }).then(res => {
        if (res.code === 0) {
          this.posterList = res.data.list
          this.total = res.data.total_row
          this.tableLoading = false
        } else {
          this.$Message.error(res.msg)
        }
      })
    },
    handleRemovePoster (item) {
      let param = {
        ids: item.id
      }
      this.$api.removePicture(param).then(res => {
        if (res.code === 0) {
          this.$Message.success(res.msg)
          this.getTableData()
        } else {
          this.$Message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  .mt18{
    margin-top: 18px;
  }
  .pic{
    width: 100px;
    height: 100px;
    border-radius: 100%;
  }
.top{
  padding-bottom: 15px;
  border-bottom: 1px dashed #d9d9d9;
}
.demo-upload-list,.demo-upload-list-wrap{
  display: inline-block;
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0,0,0,.2);
  margin-right: 4px;
  /*vertical-align: middle;*/
}
.demo-upload-list-wrap{
  border: none;
  width: 60px;
  height: 60px;
  margin: 5px 5px;
  box-shadow: none;
}
.demo-upload-list img{
  width: 100%;
  height: 100%;
  display: block;
}
.demo-upload-list-cover{
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0,0,0,.6);
}
.demo-upload-list:hover .demo-upload-list-cover{
  display: block;
}
.demo-upload-list-cover i{
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}
  .demo-upload-list-wrap .demo-upload-list-cover {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    /*margin: 0 2px;*/
    line-height: 60px;
    border-radius: 100%;
  }
  .pic_wrap{
    padding-top: 15px;
    position: relative;
  }

</style>
